import React from "react"
import { Col, Row } from "react-bootstrap"
import { CourseComplianceStats } from "./course_compliance_stats"
import { CourseCondensedFilters } from "./course_condensed_filters"
import { CourseDetailedFilters } from "./course_detailed_filters"
import { useState } from "react"
import { useSelector } from "react-redux"

export const CourseTablePreheader = () => {
  const [showAllFilters, setShowAllFilters] = useState(false)
  const courseCount = useSelector((state) => state.misc.data.courseCount)

  return(
    <div className="preheader-container">
      <Row>
        <Col md={6}>
          <CourseComplianceStats/>
        </Col>
        <Col md={6}>
          <CourseCondensedFilters showAllFilters={showAllFilters} toggleShowAllFilters={() => setShowAllFilters(!showAllFilters)}/>
        </Col>
      </Row>
      <CourseDetailedFilters show={showAllFilters}/>
      <Row>
        <Col className="course-count-container">
          Showing {courseCount} courses
        </Col>
      </Row>
    </div>
  )
}